"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const core_1 = require("@emotion/core");
const react_1 = require("react");
const FieldFocusContext_1 = require("../FieldFocusContext");
const design_system_1 = require("@zapier/design-system");
const common_1 = require("../common");
const Styles_1 = require("../common/Styles");
function PasswordField(props) {
    const onChange = (e) => props.onChange(e.target.value);
    const [isVisible, setVisible] = react_1.useState(false);
    const onToggleVisibility = () => setVisible(!isVisible);
    return (core_1.jsx(FieldFocusContext_1.ExclusiveFieldFocus, null,
        core_1.jsx(common_1.TextInput, { disabledText: props.disabledText, id: props.id, isDisabled: props.isDisabled, isErrored: props.isErrored, onBlur: props.onBlur, onChange: onChange, placeholder: props.placeholder, renderIconAfter: ({ iconSize }) => (core_1.jsx("button", { "aria-label": isVisible ? 'Hide password' : 'Show password', css: Styles_1.inputButtonStyle, onClick: onToggleVisibility },
                core_1.jsx(design_system_1.Icon, { name: isVisible ? 'actionLock' : 'miscEye', size: iconSize }))), type: isVisible ? 'text' : 'password', value: props.value })));
}
exports.default = PasswordField;
PasswordField.defaultProps = {
    onBlur: () => { },
    onChange: () => { },
};
